import styles from './App.less';

import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import Promise from 'bluebird';
import { shouldIndexPage } from '@seek/seek-jobs-seo';

import { SeekApp } from 'seek-style-guide/react';

import { getClientToken, getCandidateAccount, updateClientUserId } from 'store/user/user';
import { getMetaDescription, getCanonicalUrls } from 'store/seo/seo';
import { showIfAvailable } from 'store/peekDown/peekDown';
import { getExperiments } from 'store/experiments/experiments';

import Header from 'Header/Header';
import Footer from 'Footer/Footer';
import ContentSlider from 'ContentSlider/ContentSlider';
import ContentSpacer from 'ContentSpacer/ContentSpacer';
import Onboard from 'Onboard/Onboard';
import PeekDown from 'PeekDown/PeekDown';

const removeNulls = array => array.filter(x => x !== null);

const hooks = {
  experiment: ({ dispatch, cookies }) => cookies.JobseekerVisitorId ? dispatch(getExperiments(cookies.JobseekerVisitorId)) : null,

  getClientToken: ({ routeEnter, dispatch }) => routeEnter ? dispatch(getClientToken()) : null,

  seo({ dispatch, locale, path, query }) {
    return Promise.all([
      dispatch(getMetaDescription({ locale, path })),
      dispatch(getCanonicalUrls({ locale, path, query }))
    ]);
  },

  defer({ routeEnter, dispatch, cookies }) {
    if (routeEnter) {
      return Promise.all([
        dispatch(updateClientUserId(cookies.JobseekerVisitorId)),
        dispatch(showIfAvailable())
      ]);
    }
    return null;
  },

  authenticated: ({ routeEnter, dispatch }) => routeEnter ? dispatch(getCandidateAccount()) : null

};

function mapStateToProps({ seo, location, user, results }) {
  return {
    userAuthenticated: user.authenticated,
    userDisplayName: user.displayName,
    userReady: user.ready,
    query: location.query,
    locale: location.locale,
    canonicalUrl: seo.canonicalUrl,
    alternateUrl: seo.alternateUrl,
    metaDescription: seo.metaDescription,
    pageTitle: results.title
  };
}

@provideHooks(hooks)
@connect(mapStateToProps)
export default class App extends Component {

  static propTypes = {
    userAuthenticated: PropTypes.bool.isRequired,
    userDisplayName: PropTypes.string.isRequired,
    userReady: PropTypes.bool.isRequired,
    query: PropTypes.object,
    locale: PropTypes.string.isRequired,
    canonicalUrl: PropTypes.string,
    alternateUrl: PropTypes.string,
    metaDescription: PropTypes.string,
    children: PropTypes.node,
    pageTitle: PropTypes.string
  };

  static defaultProps = {
    pageTitle: ''
  };

  render() {
    const {
      canonicalUrl,
      alternateUrl,
      metaDescription,
      children,
      locale,
      userAuthenticated,
      userDisplayName,
      userReady,
      query,
      pageTitle
    } = this.props;

    const meta = {
      meta: removeNulls([
        metaDescription ? { name: 'description', content: metaDescription } : null,
        { name: 'robots', content: shouldIndexPage(query) }
      ]),
      link: removeNulls([
        canonicalUrl ? { rel: 'canonical', href: canonicalUrl } : null,
        alternateUrl ? { rel: 'alternate', href: alternateUrl, media: 'only screen and (max-width: 640px)' } : null
      ])
    };
    const message = 'We\'ve got a sleek new look.';

    return (
      <SeekApp title={pageTitle} meta={meta.meta} link={meta.link} locale={locale}>
        <div className={styles.root}>

          <div className={styles.content}>

            <Header {...{ locale, userAuthenticated, userDisplayName, userReady }} />

            <div role="main">{ children }</div>

            <ContentSlider trigger={['dashboard', 'searchbar', 'refinebar']}>
              <Footer {...{ locale }} />
            </ContentSlider>

            <ContentSpacer />
          </div>

          <div className={styles.peekdown}>
            <PeekDown message={message}>
              <Onboard />
            </PeekDown>
          </div>

        </div>
      </SeekApp>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/handlers/App.js
 **/